"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("../../config"));

var _browser = require("../../utils/browser");

var _antd = require("antd");

require("./style.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BrowserBanner = function BrowserBanner(_ref) {
  var intl = _ref.intl,
      supportedBrowsers = _ref.supportedBrowsers;
  var browser = (0, _browser.getBrowserDetails)();
  var supportedBrowserVersion = (0, _react.useMemo)(function () {
    var supportedBrowsersMap = supportedBrowsers || _config.default.SUPPORTED_BROWSERS;
    return supportedBrowsersMap[browser.name];
  }, [browser, supportedBrowsers]);
  var showBanner = (0, _react.useMemo)(function () {
    return supportedBrowserVersion ? browser.version < supportedBrowserVersion : false;
  }, [browser, supportedBrowserVersion]);
  return showBanner && /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: intl ? intl.formatMessage({
      id: 'browser_banner_message'
    }, {
      browserName: browser.name,
      browserSupportedVersion: supportedBrowserVersion
    }) : "Your browser version is not fully compatible with all Aplanet features.",
    banner: true
  });
};

var _default = BrowserBanner;
exports.default = _default;